"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var StarSmallOutlineYes = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_StarSmallOutlineYes_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.513 12.547a1 1 0 0 1 .974 0l2.455 1.369a.646.646 0 0 0 .943-.685l-.49-3.029a1 1 0 0 1 .269-.855l2.148-2.222c.379-.391.147-1.035-.361-1.113l-2.895-.446a1 1 0 0 1-.754-.567L8.58 2.375a.637.637 0 0 0-1.162 0L6.199 5a1 1 0 0 1-.755.567l-2.895.446c-.508.078-.74.722-.361 1.113l2.149 2.222a1 1 0 0 1 .268.855l-.49 3.029c-.09.561.49.937.943.685l2.455-1.37Zm-3.895-2.505-.49 3.03c-.22 1.365 1.216 2.387 2.417 1.717L8 13.42l2.455 1.37c1.2.669 2.638-.353 2.417-1.719l-.49-3.028 2.15-2.222c.933-.966.393-2.593-.929-2.797l-2.895-.447-1.22-2.623c-.592-1.272-2.384-1.272-2.976 0l-1.22 2.623-2.895.447c-1.322.204-1.862 1.83-.928 2.797l2.149 2.222Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_StarSmallOutlineYes_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = StarSmallOutlineYes;
exports["default"] = _default;